/**
 * Role name constants. These names are temporary and will be aligned with the backend when it is ready.
 */
export const HAM_ADMIN = 'HAM_ADMIN';
export const HAM_USER = 'HAM_USER';

export type UserRole = typeof HAM_ADMIN | typeof HAM_USER;

export type HamRoleType = 'HAM_ADMIN' | 'HAM_USER';

export function buildUserPrincipalId(accountId: string): string {
	return `ari:cloud:identity::user/${accountId}`;
}

export function buildGroupPrincipalId(groupId: string): string {
	return `ari:cloud:identity::group/${groupId}`;
}
